import React from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ICON_CANCEL, ICON_DOWNLOAD, ICON_PRINT } from '../../../extras/icons';

const ActuationPreview = props => {
    //Tomo los props
    const { show, handleClose, act, text, handleDownload } = props;
    return (
        <Modal show={show} onHide={handleClose} size="xl" scrollable={true} centered={true}>
            <Modal.Header closeButton={true}>
                <Modal.Title className="h5">
                    { act ?  `ACTA DE AUDIENCIA #${act.id}` : null }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 align-middle">
                        <div dangerouslySetInnerHTML={{__html: text ? text : ''}} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="bg-light">
                {
                    handleDownload && act ? (
                        <OverlayTrigger
                            key={`pb${act.id}`}
                            placement="left"
                            overlay={
                                <Tooltip id={`tooltip-pb${act.id}`}>
                                    DESCARGAR
                                </Tooltip>
                            }
                        >
                            <Button variant="dark" onClick={handleDownload}>
                                <ICON_DOWNLOAD /> 
                            </Button>
                        </OverlayTrigger>
                    ) : null
                }
                <Button variant="danger" onClick={handleClose}>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ActuationPreview;